import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, GlobeIcon, MailIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { costs, faqs, purchases } from '../data/closing';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-21" data-mp="3pmbrfc9mo6zq">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="3bsc8ilyzfzxk">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-primary-soft" aria-hidden="true" data-id="element-23" data-mp="3gjkibj485nb9" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="31v6h1cmgi6wt">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-primary/40 p-7 sm:p-10" data-id="element-25" data-mp="36ust3iqjth41">
            
            <p className="mt-4 text-foreground-muted" data-id="element-26" data-mp="2svjcihyfkkzj">
              Abrís los volúmenes. Aplicás el material.
            </p>
            <p className="mt-4 text-foreground-muted" data-id="element-27" data-mp="2wv205lhmza62">
              Si en 30 días no es lo que esperabas:
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-primary-soft sm:text-4xl" data-id="element-28" data-mp="2asqnxovad8nu">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="2poy32aru7jw9">sin formularios, sin explicaciones.</p>
          </div>
        </div>
      </section>
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-30" data-mp="2koto4p6kux85">
        <div className="mx-auto max-w-3xl" data-id="element-31" data-mp="1x2df7kaklpxg">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-32" data-mp="1wz7ro9hlaw3u">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-33" data-mp="26qvefx37boyz">
            {faqs.map(({
            question,
            answer
          }, index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-foreground/10 bg-surface" data-id="element-34" data-mp="1eakltorla2p7" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold transition-colors duration-150 ease-out hover:text-primary-soft sm:text-lg" data-id="element-35" data-mp="19cj3x75wg9fb">
                    <span data-id="element-36" data-mp="27t8aaiy38q3d">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-primary-soft transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-37" data-mp="27u9x1kogv10x" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-38" data-mp="1k2mdxoxg4u97">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-39" data-mp="1k2w6nk9vlfil">
                        <p className="border-t border-foreground/10 px-5 py-5 leading-relaxed text-foreground-muted" data-id="element-40" data-mp="35hs2ommtzn0p">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-41" data-mp="f3fpqofiuipf">
      <div className="mx-auto max-w-4xl" data-id="element-42" data-mp="b2nig0q7mnvs">
        <h2 className="text-center font-display text-3xl font-bold text-highlight sm:text-4xl" data-id="element-43" data-mp="b3fc3608ybjf">
          ⚖️ ¿CUÁNTO TE CUESTA SEGUIR IMPROVISANDO?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-line-strong" data-id="element-44" data-mp="134znnm1d85b">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-line-strong border-l-line-accent bg-surface-raised px-5 py-4 font-medium last:border-b-0" data-id="element-45" data-mp="3sbarvfswux96">
              <span className="mr-2 text-danger-soft" aria-hidden="true" data-id="element-46" data-mp="1vfla70lv78fz">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <div className="mt-10 text-center" data-id="element-47" data-mp="1yk3o1g9vkmte">
          
          <p className="mt-3 font-display text-2xl font-bold text-primary-soft sm:text-3xl" data-id="element-48" data-mp="23idmq0ut65jr">
            No necesitás más recetas. Necesitás un sistema.
          </p>
        </div>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: number | undefined;
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => {
      window.clearInterval(timer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  return <>
      <footer className="border-t border-foreground/10 bg-canvas px-4 py-12 text-center" data-id="element-49" data-mp="wvhzfiy61oo6">
        <span className="inline-block rounded-full border border-primary/25 bg-primary/10 px-3 py-1 text-sm font-semibold text-primary-soft" data-id="element-50" data-mp="10uqwawoi62ny">
          PACK COMIDAS RESUELTAS™
        </span>
        
        
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-foreground-subtle" data-id="element-51" data-mp="d9q5eqlk8no2">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary-soft" href="mailto:soportebiomalivido@gmail.com" data-id="element-52" data-mp="r9r5w4xwxt30">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="115ki1n7pzkk9" />
            soportebiomalivido@gmail.com
          </a>
          <span className="inline-flex items-center gap-1.5" data-id="element-54" data-mp="w6hph28xf6t6">
            <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="19yfo2j50hkb3" />
            @biomalivido
          </span>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary-soft" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-56" data-mp="15wu64jdmefu1">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="1ey0mmsg9rqna" />
            biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-foreground-faintest" data-id="element-58" data-mp="cl5n98n0xkij">
          © PACK COMIDAS RESUELTAS™ 2026 — Todos los derechos reservados.
        </p>
      </footer>
      <AnimatePresence data-id="element-59" data-mp="ll115l7yrtm9">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-72 rounded-xl border border-primary/30 bg-canvas p-4 shadow-2xl" aria-live="polite" data-id="element-60" data-mp="lksptxrhowd6">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-primary-soft" data-id="element-61" data-mp="14baenr97b7t9">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-62" data-mp="199bvs6n2gx23" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-63" data-mp="364q4wn1dmknp">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-foreground-muted" data-id="element-64" data-mp="33i79nbl477hf">
              compró Pack Comidas Resueltas™
            </p>
            <p className="mt-1 text-xs text-foreground-faint" data-id="element-65" data-mp="2yrh49ycov4mq">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}